import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Card, Col, Container, Input, Label, Row, Button, Modal, ModalBody } from 'reactstrap';
import axios from 'axios';
import ReactInputVerificationCode from 'react-input-verification-code';
import { useInterval } from "usehooks-ts";
// import ReCAPTCHA from 'react-google-recaptcha'

import logoTelkom from "../../../assets/images/telkom/logoACI.png";
import Welcome from "../../../assets/images/telkom/welcomeNew.png";

const CoverSignInterview = () => {
    document.title = "Login Admin";
    // ---- Buat ngecheck, sudah pernah login, bakalan di lempar ke Dashboard ---- //
    if (localStorage.getItem('user') != null) {
        window.localStorage.clear()
    }
    if (sessionStorage.getItem('user') != null) {
        window.location.href = '/i1';
    }

    // ---- Input Data Login ---- //
    const [email, setEmail] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorPassword, setErrorPassword] = useState('');

    // --- Alert Error --- //
    const [errorSubmit, setErrorSubmit] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    
    // --- Alert Error OTP --- //
    const [errorOTP, setErrorOTP] = useState(true);
    const [errorMessageOTP, setErrorMessageOTP] = useState('');

    // -- Tombol Show Password -- //
    const [showPass, setShowPass] = useState(false);

    // --- NO DOUBLE CLICK ! --- //
    const [isDouble, setIsDouble] = useState(false);

    // --- OTP After Login --- //
    const [otp, setOTP] = useState('');

    // --- Open MODAL OTP After Login --- //
    const [modalOTP, setModalOTP] = useState(false);

    // --- Get Data After Login --- //
    const [userID, setUserID] = useState("");
    const [emailEncrypt, setEmailEncrypt] = useState("");
    const [namaEncrypt, setNamaEncrypt] = useState("");

    // --------- MODAL ----------- //
    // const [modalReCAPTCHA, setModalReCAPTCHA] = useState(false);

    // ReCAPTCHA
    // const captchaRef = useRef(null)

    // ---- onChange Input Data ---- //
    const changeEmail = (event) => {
        const value = event.target.value
        setEmail(value)
        if (!value) {
            setErrorEmail('Maaf, email tidak boleh kosong!')
        } else {
            setErrorEmail('')
        }
    }
    const changePassword = (event) => {
        const value = event.target.value
        setPassword(value)
        if (!value) {
            setErrorPassword('Maaf, password tidak boleh kosong!')
        } else {
            setErrorPassword('')
        }
    }

    // -- Tombol Show Password -- //
    const shower = () => {
        setShowPass(!showPass);
    }

    // -- Fungsi Get Error Message dari Error Code -- //
    const getErrorMessage = (errorCode) => {
        switch (errorCode) {
            case "E1":
                return "Sesi Anda telah berakhir. Silakan login kembali.";
            case "CE1":
            case "CE2":
                return "Data tidak valid. Silakan periksa kembali.";
            case "IF1":
                return "Data yang diminta tidak tersedia.";
            case "CE3":
                return "Kode tidak dapat digunakan.";
            case "SE1":
                return "Email tidak dapat digunakan.";
            case "PM1":
                return "Email atau password tidak valid.";
            case "PM2":
                return "Konfirmasi password tidak sesuai.";
            case "IF2":
                return "Data tidak lengkap.";
            case "EF1":
                return "Permintaan tidak dapat diproses.";
            case "OM1":
                return "Kode verifikasi tidak valid.";
            case "NC1":
                return "Konfirmasi password tidak sesuai.";
            case "AP1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "EX1":
                return "File tidak dapat diproses.";
            case "NX1":
                return "File belum dipilih.";
            case "AK1":
                return "Akses tidak valid.";
            case "FS1":
                return "Ukuran file melebihi batas maksimum yang diizinkan.";
            case "SQ1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "MN1":
                return "Gagal memproses file. Silakan coba kembali.";
            case "EV1":
                return "Data yang dikirim tidak valid.";
            case "NM1":
                return "Gagal mengirim notifikasi. Silakan coba kembali.";
            case "RL1":
                return "Terlalu banyak permintaan. Silakan coba kembali beberapa saat lagi.";
            default:
                return errorCode;
        }
    }

    const [modalLimitLogin, setModalLimitLogin] = useState(false);


    // -- Fungsi Login -- //
    const loginButton = () => {

        setIsDouble(true)

        // if (captchaRef.current.getValue() !== "") {
        const data = JSON.stringify({
            email: email,
            password: password,
        });

        const config = {
            method: 'post',
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/admin/login`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
        };

        axios(config).then((response) => {
            setIsDouble(false)
            console.log(response)

            if (response && response.results) {
                let emailEnc = response.results.email;
                let userId = response.results.id;
                let namaEnc = response.results.nama;

                setUserID(userId)
                setEmailEncrypt(emailEnc)
                setNamaEncrypt(namaEnc)

                // Reset error states
                setErrorOTP(true);
                setErrorMessageOTP('');
                setOTP('');
                
                setModalOTP(true)
            }
            // console.log(response.results.token)
            // localStorage.setItem('user', JSON.stringify(response))

            // sessionStorage.setItem('user', JSON.stringify(response))
            // window.location.href = '/i1'
        }).catch((error) => {
            setIsDouble(false)
            console.log(error)

            if (error.response && error.response.data && error.response.data.error) {
                const errorCode = error.response.data.error;
                
                if (errorCode == "Request failed with status code 429" || errorCode === "RL1") {
                    setModalLimitLogin(true)
                } else {
                    const message = getErrorMessage(errorCode);
                    setErrorMessage(message);
                    setErrorSubmit(false);
                    setTimeout(() => {
                        setErrorSubmit(true)
                        setErrorMessage('')
                    }, 5000)
                }
            } else {
                setErrorMessage("Terjadi kesalahan. Silakan coba kembali.");
                setErrorSubmit(false);
                setTimeout(() => {
                    setErrorSubmit(true)
                    setErrorMessage('')
                }, 5000)
            }
        })


        // } else {
        //     setModalReCAPTCHA(true)
        // }

    }

    const verifyOTP = () => {
        let data = JSON.stringify({
            "user_id": userID,
            "email": emailEncrypt,
            "name": namaEncrypt,
            "otp_code": otp
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/admin/verifikasiKodeOtpAdmin`,
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };

        axios.request(config)
            .then((response) => {
            // console.log(response);

                if(response.status == 200) {
                    // Reset error states
                    setErrorOTP(true);
                    setErrorMessageOTP('');
                    
                    sessionStorage.setItem('user', JSON.stringify({results: {id: userID, nama:namaEncrypt, email: emailEncrypt, token: response.token, api_key: response.token}}));
                    window.location.href = '/i1';

                    setModalOTP(false);
                }
            })
            .catch((error) => {
                console.log(error);
                
                if (error.response && error.response.data && error.response.data.error) {
                    const errorCode = error.response.data.error;
                    const message = getErrorMessage(errorCode);
                    setErrorMessageOTP(message);
                    setErrorOTP(false);
                    setTimeout(() => {
                        setErrorOTP(true)
                        setErrorMessageOTP('')
                    }, 5000)
                } else {
                    setErrorMessageOTP("Terjadi kesalahan. Silakan coba kembali.");
                    setErrorOTP(false);
                    setTimeout(() => {
                        setErrorOTP(true)
                        setErrorMessageOTP('')
                    }, 5000)
                }
            });
    }


    return (
        <React.Fragment>
            <style>
                {`
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                            max-height: 0;
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                            max-height: 100px;
                        }
                    }
                `}
            </style>
            <Row style={{ margin: '0px', height: '100vh', alignItems: 'center', fontFamily: 'Nunito' }}>
                {/* Ini Welcome! Lets Get Started */}
                <Col md={12} lg={6} xl={6} style={{ height: '100%', padding: '0px' }}>
                    <img src={Welcome} style={{ height: '-webkit-fill-available' }} />
                </Col>
                <Col md={12} lg={6} xl={6} style={{ padding: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                    <div style={{ display: 'flex', justifyContent: 'center', marginRight: '50px' }}>
                        <img src={logoTelkom} />
                    </div>

                    <div style={{ marginTop: '50px', padding: '25px', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.08)', borderRadius: '8px', width: '65%', marginRight: '50px' }}>

                        {/* ---- HEADER Masuk ---- */}
                        <p style={{ fontWeight: '700', fontSize: '30px', color: '#F56565', textAlign: 'center' }}>Masuk</p>
                        {!errorSubmit && errorMessage && (
                            <Alert 
                                color="danger" 
                                style={{ 
                                    textAlign: 'center', 
                                    backgroundColor: '#FEE2E2', 
                                    color: '#DC2626', 
                                    borderColor: '#FCA5A5', 
                                    borderLeft: '4px solid #DC2626',
                                    margin: '10px 0px 20px 0px', 
                                    borderRadius: '6px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    animation: 'slideDown 0.3s ease-out',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                                }}
                                onClose={() => {
                                    setErrorSubmit(true);
                                    setErrorMessage('');
                                }}
                                toggle={() => {
                                    setErrorSubmit(true);
                                    setErrorMessage('');
                                }}
                            >
                                <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                                {errorMessage}
                            </Alert>
                        )}

                        {/* ---- Masukin Data Email ---- */}
                        <div className="mb-3" >
                            <Label style={{ fontSize: '14px' }} htmlFor="email" className="form-label">Email</Label>
                            <Input style={{ fontSize: '14px' }} type="text" value={email} onChange={changeEmail} className="form-control" id="email" placeholder="Enter Email" maxLength={60} required />
                            {errorEmail && (
                                <p style={{ margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute' }}>{errorEmail}</p>
                            )}
                        </div>

                        {/* ---- Masukin Data Password ---- */}
                        <div className="mb-3">
                            <Label style={{ fontSize: '14px' }} className="form-label" htmlFor="password-input">Password</Label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input style={{ fontSize: '14px' }} type={showPass ? "text" : "password"} value={password} onChange={changePassword} className="form-control pe-5" placeholder="Enter password" id="password-input" required />
                                <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={shower} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                            </div>
                            {errorPassword && (
                                <p style={{ margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute' }}>{errorPassword}</p>
                            )}
                        </div>

                        {/* ---- Submit Login ---- */}
                        {/* <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} ref={captchaRef} /> */}
                        <div className="mt-4">
                            <Button style={{ fontSize: '14px' }} color="success" className="w-100" onClick={loginButton} disabled={isDouble}>Masuk</Button>
                        </div>
                        <p style={{ marginTop: '20px', fontSize: '14px' }}>
                            Lupa kata sandi ? {" "}
                            <Link style={{ fontWeight: '700', fontSize: '18px', color: '#F56565', cursor: 'pointer' }} to='/forgot-password'>
                                Reset
                            </Link>
                        </p>
                    </div>
                </Col>
            </Row>

            {/* ------- MODAL CAPTCHA ------- */}
            {/* <Modal isOpen={modalReCAPTCHA} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h5 style={{ textAlign: "center", padding: "0 70px", margin: '50px 0px' }}>
                            reCAPTCHA dulu kawan
                        </h5>
                        <Button color="success" onClick={() => { setModalReCAPTCHA(false) }}>Oke Deh</Button>
                    </div>
                </ModalBody>
            </Modal> */}
            <Modal isOpen={modalLimitLogin} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h5 style={{ textAlign: "center", padding: "0 50px", margin: '50px 0px' }}>
                            Terlalu banyak melakukan percobaan,<br />Mohon tunggu beberapa menit
                        </h5>
                        <Button color="success" onClick={() => { setModalLimitLogin(false) }} >Oke Deh</Button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={modalOTP} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto", padding: '30px' }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: '100%' }}>
                        <p style={{fontWeight: '700', fontSize: '30px', color: '#F56565', textAlign: 'center', marginBottom: '20px'}}>Verifikasi OTP</p>

                        {!errorOTP && errorMessageOTP && (
                            <Alert 
                                color="danger" 
                                style={{ 
                                    textAlign: 'center', 
                                    backgroundColor: '#FEE2E2', 
                                    color: '#DC2626', 
                                    borderColor: '#FCA5A5', 
                                    borderLeft: '4px solid #DC2626',
                                    margin: '0px 0px 20px 0px', 
                                    borderRadius: '6px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    width: '100%',
                                    animation: 'slideDown 0.3s ease-out',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                                }}
                                onClose={() => {
                                    setErrorOTP(true);
                                    setErrorMessageOTP('');
                                }}
                                toggle={() => {
                                    setErrorOTP(true);
                                    setErrorMessageOTP('');
                                }}
                            >
                                <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                                {errorMessageOTP}
                            </Alert>
                        )}

                        <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                            <ReactInputVerificationCode value={otp} onChange={(value) => {
                                setOTP(value);
                                // Reset error when user starts typing
                                if (errorMessageOTP) {
                                    setErrorOTP(true);
                                    setErrorMessageOTP('');
                                }
                            }}/>
                        </div>
                        
                        <p style={{textAlign: 'center', marginTop: '20px', fontSize: '14px'}}> 
                            Anda masuk belum menerima kode? 
                            <span style={{fontWeight: '700', fontSize: '16px', color: '#F56565', cursor: 'pointer', marginLeft: '4px'}} onClick={() => {
                                setErrorOTP(true);
                                setErrorMessageOTP('');
                                loginButton();
                                }}>Kirim Ulang</span>
                        </p>
                        
                        <div className="text-center mt-2" style={{width: '100%'}}>
                            <Button style={{fontSize: '14px'}} color="success" className="w-100" onClick={() => {
                                verifyOTP();
                                // onNext(); 
                                }}>
                                Verifikasi
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default CoverSignInterview;